import React from "react";
import { Checkbox, CheckboxProps } from "antd";

const VLCheckBox: React.FC<CheckboxProps> = (props) => {
  const { ...restProps } = props;

  return <Checkbox {...restProps} />;
};

export default VLCheckBox;
